// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"226":"fa30de31","481":"fa30de31","622":"fa30de31","868":"fa30de31"}[chunkId] + ".chunk.css";
};